import React from 'react';
import classNames from 'classnames';
import { Link } from 'gatsby';

import './NetworkCardLink.scss';

import { INetwork } from '../../utils/models';
import { getOptimizedImage } from '../../utils/getOptimizedImage';
import { generateSlug } from '../../utils/helpers';

export interface INetworkCardLinkProps {
  network: INetwork;
  maxLogoUrl: string;
  linkPath?: string;
  linkClassName?: string;
  linkTitle?: string;
  ariaLabel?: string;
  onClick?: Function;
}

const NetworkCardLink = ({
  network: { displayName, networkImgUrl, path },
  maxLogoUrl,
  linkPath,
  linkClassName,
  linkTitle,
  ariaLabel,
  onClick,
}: INetworkCardLinkProps) => {
  const imageUrl =
    displayName === 'Max' || displayName === 'HBO Max' || displayName === 'HBO'
      ? getOptimizedImage({ url: maxLogoUrl, width: 200 })
      : `${networkImgUrl}&sourceType=colorHybrid&twccategory=Poster&width=170`;

  const modifiedDisplayName =
    displayName === 'HBO Max' || displayName === 'HBO' || displayName === 'Max'
      ? 'Max'
      : displayName;

  const applyNetworkPathModifications = (initialPath: string) => {
    if (initialPath.includes('hbo') || initialPath.includes('hbo-max')) {
      return '/networks/max/';
    }
    
    if (initialPath.includes('mgm')) {
      return '/networks/mgmplus';
    }

    return initialPath;
  };

  const generatePath = (networkDisplayName: string, initialPath?: string) => {
    if (initialPath) return applyNetworkPathModifications(initialPath);

    const newPath = `/networks/${generateSlug(networkDisplayName)}`;

    return applyNetworkPathModifications(newPath);
  };

  const linkAttributes = {
    title: linkTitle || displayName,
  };

  if (linkClassName) linkAttributes['className'] = linkClassName;
  if (ariaLabel) linkAttributes['aria-label'] = ariaLabel;
  if (onClick) linkAttributes['onClick'] = onClick;

  return (
    <Link to={generatePath(displayName, linkPath || path)} {...linkAttributes}>
      <figure className="network-card">
        <img
          className={classNames({
            'network-card__image': true,
            'network-card__image--max': displayName === 'Max',
          })}
          src={imageUrl}
          alt=""
          loading="lazy"
        />
        <figcaption className="network-card__caption">
          {modifiedDisplayName}
        </figcaption>
      </figure>
    </Link>
  );
};

export default NetworkCardLink;
